// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"07bb0fb9","215":"d1d012c4"}[chunkId] + ".chunk.js";
};